/**
 * ButtonMappingBuilder Class
 *
 * Used by ColumnBuilder.withButton(...) to map cell values to a rendered button.
 */
export class ButtonMappingBuilder {
    constructor() {
        this._mappings = [];
        this._current = null;
        this._default = null;
    }

    when(value) {
        this._current = {
            val: value,
            key: null,
            text: value,
            icon: null,
            className: 'btn-outline-secondary',
            title: null,
            showIf: null,
            callback: null,
            color: null,
            textColor: null
        };
        this._mappings.push(this._current);
        return this;
    }

    /**
     * Fallback mapping for values that do not match any `.when(...)`.
     * Without `.text()`, the raw cell value is used as the button label.
     * @returns {this}
     */
    default() {
        this._current = {
            key: null,
            text: null,
            icon: null,
            className: 'btn-outline-secondary',
            title: null,
            showIf: null,
            callback: null,
            color: null,
            textColor: null
        };
        this._default = this._current;
        return this;
    }

    /**
     * Sets the action key used for data-action and callback lookup.
     */
    key(actionKey) {
        if (this._current) this._current.key = actionKey;
        return this;
    }

    /**
     * Visible button label.
     */
    withText(label) {
        if (this._current) this._current.text = label;
        return this;
    }

    /**
     * Tooltip/title attribute.
     */
    withTitle(title) {
        if (this._current) this._current.title = title;
        return this;
    }

    withIcon(iconClass) {
        if (this._current) this._current.icon = iconClass;
        return this;
    }

    withClass(className) {
        if (this._current) this._current.className = className;
        return this;
    }

    withBackgroundColor(color) {
        if (this._current) this._current.color = color;
        return this;
    }

    withTextColor(color) {
        if (this._current) this._current.textColor = color;
        return this;
    }

    showIf(conditionFn) {
        if (this._current) this._current.showIf = conditionFn;
        return this;
    }

    onClick(cb) {
        if (this._current) this._current.callback = cb;
        return this;
    }

    _getMappings() {
        return this._mappings;
    }

    _getDefault() {
        return this._default;
    }
}

